import React, { useState, useRef, useEffect } from "react";
import "../Style/Component/SimpleRichEditor.css";
import {
  MdFormatAlignLeft,
  MdFormatAlignCenter,
  MdFormatAlignRight,
} from "react-icons/md";
const SimpleRichEditor = ({key, value, index,onChange }) => {
  const [content, setContent] = useState(value || "");
  const editorRef = useRef();
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const isInitialized = useRef(false);

//     useEffect(() => {
//     if (editorRef.current) {sid
//       editorRef.current.innerHTML = value || "";
//       updateCharCount();
//     }
//   }, [value]);

  useEffect(() => {
    if (editorRef.current && document.activeElement !== editorRef.current) {
      editorRef.current.innerHTML = value || "";
      setContent(value || "");
      updateCharCount();
    }
  }, [value]);

  useEffect(() => {
    updateCharCount();
  }, [content]);

  const updateCharCount = () => {
    if (editorRef.current) {
      const text = editorRef.current.textContent || "";
      setCharCount(text.length);
    }
  };

  const handleInput = () => {
    const html = editorRef.current.innerHTML;
    setContent(html);
    onChange(index, "description", html);
    updateCharCount();
  };

  const execCommand = (command) => {
    document.execCommand(command, false, null);
    editorRef.current.focus();

    // Update button states
    if (command === "bold") setIsBold(!isBold);
    if (command === "italic") setIsItalic(!isItalic);
    if (command === "underline") setIsUnderline(!isUnderline);
  };

  const insertList = (type) => {
    if (type === "bullet")
      document.execCommand("insertUnorderedList", false, null);
    if (type === "number")
      document.execCommand("insertOrderedList", false, null);
    editorRef.current.focus();
  };

  return (
    <div className="editor-container">
      <label className="editor-label">
        Description <span className="required">*</span>
      </label>

      {/* Editor Toolbar */}
      <div className="editor-toolbar">
        <div className="toolbar-group">
          <button
            type="button"
            onClick={() => execCommand("bold")}
            className={`toolbar-btn ${isBold ? "active" : ""}`}
            title="Bold"
          >
            <span className="btn-icon">B</span>
            <span className="btn-text">Bold</span>
          </button>
          <button
            type="button"
            onClick={() => execCommand("italic")}
            className={`toolbar-btn ${isItalic ? "active" : ""}`}
            title="Italic"
          >
            <span className="btn-icon">I</span>
            <span className="btn-text">Italic</span>
          </button>
          <button
            type="button"
            onClick={() => execCommand("underline")}
            className={`toolbar-btn ${isUnderline ? "active" : ""}`}
            title="Underline"
          >
            <span className="btn-icon">U</span>
            <span className="btn-text">Underline</span>
          </button>
        </div>

        <div className="toolbar-group">
          <button
            type="button"
            onClick={() => insertList("bullet")}
            className="toolbar-btn"
            title="Bullet List"
          >
            <span className="btn-icon">•</span>
            <span className="btn-text">Bullets</span>
          </button>
          <button
            type="button"
            onClick={() => insertList("number")}
            className="toolbar-btn"
            title="Numbered List"
          >
            <span className="btn-icon">1.</span>
            <span className="btn-text">Numbers</span>
          </button>
        </div>

        <div className="toolbar-group">
          <button
            type="button"
            onClick={() => execCommand("justifyLeft")}
            className="toolbar-btn"
            title="Align Left"
          >
            <MdFormatAlignLeft className="btn-icon" />
            <span className="btn-text">Left</span>
          </button>

          <button
            type="button"
            onClick={() => execCommand("justifyCenter")}
            className="toolbar-btn"
            title="Align Center"
          >
            <MdFormatAlignCenter className="btn-icon" />
            <span className="btn-text">Center</span>
          </button>

          <button
            type="button"
            onClick={() => execCommand("justifyRight")}
            className="toolbar-btn"
            title="Align Right"
          >
            <MdFormatAlignRight className="btn-icon" />
            <span className="btn-text">Right</span>
          </button>
        </div>
      </div>

      {/* Editor Content Area */}
      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        className="editor-content"
        data-placeholder="Enter detailed description..."
      />
    </div>
  );
};

export default SimpleRichEditor;
